module.exports = __webpack_public_path__ + "./workspace-01_b4e3f8077accc6ff09752d29fad30283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/2025/workspace-01.jpg
// module id = 627
// module chunks = 0